export enum ToothIssue {
	BLEEDING = 'bleeding',
	PLAQUE = 'plaque',
	PUS = 'pus',
	TARTAR = 'tartar',
}
